<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('application.title'),
            subtitle: {
                first_text: $t('application.label'),
                first_href: '/',
                second_text: $t('application.title')
            }
        }" />

        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-12 d-flex flex-column justify-content-center ">
                    <h2 class="title">{{ $t('application.about_the_application') }}</h2>
                    <p class="desc">{{ $t('application.description') }}</p>
                </div>
                <div class="col-lg-6 col-12">
                    <img src="@/assets/images/application/main.webp" alt="application" class="main_img">
                </div>
            </div>
            <div class="row">
                <h2 class="title"> {{ $t('application.app_pros') }} </h2>
            </div>
            <div class="row">
                <!-- Column 1 -->
                <div class="col-md-6 d-flex align-items-start">
                    <img src="@/assets/images/application/pros1.png" alt="application" class="me-2 pros_img">
                    <div>
                        <h5> {{ $t('application.pros1_title') }}</h5>
                        <p>{{ $t('application.pros1_paragraph') }}</p>
                    </div>
                </div>
                <!-- Column 2 -->
                <div class="col-md-6 d-flex align-items-start">
                    <img src="@/assets/images/application/pros2.png" alt="application" class="me-2 pros_img">
                    <div>
                        <h5> {{ $t('application.pros2_title') }}</h5>
                        <p>{{ $t('application.pros2_paragraph') }}</p>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <!-- Column 3 -->
                <div class="col-md-6 d-flex align-items-start">
                    <img src="@/assets/images/application/pros3.png" alt="application" class="me-2 pros_img">
                    <div>
                        <h5> {{ $t('application.pros3_title') }}</h5>
                        <p>{{ $t('application.pros3_paragraph') }}</p>
                    </div>
                </div>
                <!-- Column 4 -->
                <div class="col-md-6 d-flex align-items-start">
                    <img src="@/assets/images/application/pros4.png" alt="application" class="me-2 pros_img">
                    <div>
                        <h5> {{ $t('application.pros4_title') }}</h5>
                        <p>{{ $t('application.pros4_paragraph') }}</p>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <!-- Column 5 -->
                <div class="col-md-6 d-flex align-items-start">
                    <img src="@/assets/images/application/pros5.png" alt="application" class="me-2 pros_img">
                    <div>
                        <h5> {{ $t('application.pros5_title') }}</h5>
                        <p>{{ $t('application.pros5_paragraph') }}</p>
                    </div>
                </div>
                <!-- Column 6 -->
                <div class="col-md-6 d-flex align-items-start">
                    <img src="@/assets/images/application/pros6.png" alt="application" class="me-2 pros_img">
                    <div>
                        <h5> {{ $t('application.pros6_title') }}</h5>
                        <p>{{ $t('application.pros6_paragraph') }}</p>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-md-6 d-flex align-items-start">
                    <img src="@/assets/images/application/pros7.png" alt="application" class="me-2 pros_img">
                    <div>
                        <h5> {{ $t('application.pros7_title') }}</h5>
                        <p>{{ $t('application.pros7_paragraph') }}</p>
                    </div>
                </div>
            </div>
            <h2 class="title guid">{{ $t('application.user_guide') }}</h2>
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <FramedCard :centeredFrame="true" :title="$t('application.guide1_title')"
                        :content="`<ul><li>${$t('application.guide1_desc_1')}</li><li>${$t('application.guide1_desc_2')}</li><li>${$t('application.guide1_desc_3')}</li></ul>`" />
                </div>
                <div class="col-md-4">
                    <FramedCard :centeredFrame="true" :title="$t('application.guide2_title')"
                        :content="`<ul><li>${$t('application.guide2_desc_1')}</li><li>${$t('application.guide2_desc_2')}</li><li>${$t('application.guide2_desc_3')}</li></ul>`" />
                </div>
                <div class="col-md-4">
                    <FramedCard :centeredFrame="true" :title="$t('application.guide3_title')"
                        :content="`<ul><li>${$t('application.guide3_desc_1')}</li><li>${$t('application.guide3_desc_2')}</li><li>${$t('application.guide3_desc_3')}</li></ul>`" />
                </div>
                <div class="col-md-4 r2">
                    <FramedCard :centeredFrame="true" :title="$t('application.guide4_title')"
                        :content="`<ul><li>${$t('application.guide4_desc_1')}</li><li>${$t('application.guide4_desc_2')}</li></ul>`" />
                </div>
                <div class="col-md-4 r2">
                    <FramedCard :centeredFrame="true" :title="$t('application.guide5_title')"
                        :content="`<ul><li>${$t('application.guide5_desc_1')}</li><li>${$t('application.guide5_desc_2')}</li><li>${$t('application.guide5_desc_3')}</li></ul>`" />
                </div>
            </div>

            <div class="download">
                <h2>{{ $t('application.download_title') }}</h2>
                <p>{{ $t('application.download_paragraph') }}</p>
                <div class="d-flex flex-row">
                    <img src="@/assets/images/application/playstore.webp">
                    <img src="@/assets/images/application/appstore.webp" @click="directToAppStore">

                </div>
            </div>
        </div>
        <AppFooter />

    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import PagesHero from '@/components/PagesHero.vue';
import FramedCard from '@/components/FramedCard.vue';

export default {
    components: {
        AppFooter, AppNavbar, PagesHero, FramedCard
    },
    methods: {
        directToAppStore() {
            let link = 'https://apps.apple.com/us/app/%D9%85%D9%86%D8%B5%D8%A9-%D8%A7%D9%84%D9%81%D8%B1%D9%82%D8%A7%D9%86/id1659488333';
            window.location.href = link;
        }
    }
}

</script>

<style scoped>
.container {
    padding-bottom: 80px;
}

.main_img {
    width: 100%;
    /* Ensures the image fits the column width */
    height: auto;
    /* Maintains aspect ratio */
    object-fit: cover;
    max-width: 100%;
    /* Prevents it from exceeding container width */
}

.title {
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 40px;
}

.desc {
    font-size: 24px;
    font-weight: 400;
}

h5 {
    font-weight: 500;
    font-size: 24px;
}

.pros_img {
    width: 45px;
    height: auto;
    margin-inline-end: 10px;
}


.col-md-4 {
    margin-top: 65px;
}

.guid {
    margin-top: 40px;
}

.download {
    margin-top: 60px;
    background-image: url('@/assets/images/application/download_bk.webp');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: auto;
    min-height: 260px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 30px;
    justify-content: space-between;

}

.download h2 {
    font-size: 40px;
    font-weight: 500;
    color: white;
}

.download p {
    font-size: 24px;
    font-weight: 400;
    color: white;
}

.download .d-flex img {
    height: 85px;
    width: auto;
    object-fit: cover;
    padding-bottom: 25px;
    margin-inline-end: 15px;
    cursor: pointer;
}

.sub_image {
    width: 100%;
    /* Take full width */
    height: auto;
    /* Keep aspect ratio */
    object-fit: cover;
    /* Fill the container while maintaining aspect ratio */
}
</style>
